<template>
  <div class="stripe-return">
    <EsHeaderView />
    <div class="app-container">
      <div class="stripe-return-content">
        <template v-if="status === 'checking'">
          <div class="loading-icon">
            <i class="el-icon-loading"></i>
          </div>
          <h2>{{ $t('message.home.confirmingPayment') || 'Confirming Payment...' }}</h2>
          <p>{{ $t('message.home.pleaseWait') || 'Please wait while we confirm your payment' }}</p>
        </template>

        <template v-else-if="status === 'success'">
          <span class="iconfont icon-icon_duihao-mian success-icon"></span>
          <h2>{{ $t('message.home.paymentSuccessful') }}</h2>
          <p>{{ $t('message.home.redirecting') || 'Redirecting to order page...' }}</p>
        </template>

        <template v-else-if="status === 'pending'">
          <span class="iconfont icon-shijian pending-icon"></span>
          <h2>{{ $t('message.home.paymentPending') || 'Payment Pending' }}</h2>
          <p>{{ $t('message.home.paymentPendingDesc') || 'Your payment is being processed. Please check back later.' }}</p>
          <div class="btn-group">
            <el-button @click="goHome">{{ $t('message.home.BackHome') || 'Back to Home' }}</el-button>
            <el-button type="primary" @click="checkOrder">{{ $t('message.home.Checkorder') || 'Check Order' }}</el-button>
          </div>
        </template>

        <template v-else-if="status === 'failed'">
          <span class="iconfont icon-guanbi error-icon"></span>
          <h2>{{ $t('message.home.paymentFailed') || 'Payment Failed' }}</h2>
          <p>{{ errorMessage || $t('message.home.paymentFailedDesc') || 'Payment confirmation failed. Please try again or contact customer service.' }}</p>
          <div class="btn-group">
            <el-button @click="retryPayment">{{ $t('message.home.retryPayment') || 'Retry Payment' }}</el-button>
            <el-button type="primary" @click="goHome">{{ $t('message.home.BackHome') || 'Back to Home' }}</el-button>
          </div>
        </template>

        <template v-else>
          <span class="iconfont icon-guanbi error-icon"></span>
          <h2>{{ $t('message.home.paymentError') || 'Payment Error' }}</h2>
          <p>{{ errorMessage || $t('message.home.paymentErrorDesc') || 'An error occurred. Please try again.' }}</p>
          <div class="btn-group">
            <el-button @click="goHome">{{ $t('message.home.BackHome') || 'Back to Home' }}</el-button>
            <el-button type="primary" @click="contactService">{{ $t('message.home.contactService') || 'Contact Service' }}</el-button>
          </div>
        </template>
      </div>
      <EsIconTips />
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import EsIconTips from '@/components/iconTips'
import { openChatPage } from '@/util'
import { is_pay_success } from '@/api/order/payment.js'

export default {
  name: 'StripeReturn',
  components: { EsIconTips },
  data() {
    return {
      status: 'checking',
      errorMessage: '',
      paymentLogSn: ''
    }
  },
  mounted() {
    const sn = this.$route.query.sn
    if (!sn) {
      this.status = 'error'
      this.errorMessage = this.$t('message.home.paymentInfoMissing') || 'Payment information missing, please place order again'
      return
    }
    this.paymentLogSn = sn
    this.verifyPayment()
  },
  methods: {
    async verifyPayment() {
      this.status = 'checking'
      try {
        const res = await is_pay_success({ paymentLogSn: this.paymentLogSn })
        if (res.data?.data?.isPaySuccess) {
          this.status = 'success'
          setTimeout(() => {
            this.$router.replace('/paySuccess')
          }, 1500)
        } else {
          this.status = 'pending'
        }
      } catch (e) {
        this.status = 'failed'
        this.errorMessage = e?.message || this.$t('message.home.paymentConfirmFailed') || 'Payment confirmation failed'
      }
    },
    goHome() {
      this.$router.replace('/')
    },
    checkOrder() {
      this.$router.replace('/userInfo/my-order?index=2')
    },
    retryPayment() {
      this.$router.replace('/settlement?skuId=&marketingId=&quantity=1')
    },
    contactService() {
      const { id, name } = JSON.parse(localStorage.getItem('seller_cache') || '{}')
      openChatPage(localStorage.getItem('BIZ_TOKEN'), id, name)
    }
  }
}
</script>

<style lang="scss" scoped>
.stripe-return {
  min-height: 100vh;
  position: relative;
  background: #f5f5f5;

  &-content {
    text-align: center;
    padding: 84px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 200px);

    .loading-icon {
      margin-bottom: 24px;
      i {
        font-size: 64px;
        color: var(--color-main);
      }
    }

    .success-icon {
      color: var(--color-main);
      font-size: 96px;
      margin-bottom: 24px;
    }

    .pending-icon {
      color: #E6A23C;
      font-size: 96px;
      margin-bottom: 24px;
    }

    .error-icon {
      color: #F56C6C;
      font-size: 96px;
      margin-bottom: 24px;
    }

    h2 {
      font-weight: 600;
      font-size: 24px;
      color: var(--color-title);
      margin-bottom: 12px;
    }

    p {
      font-weight: 500;
      font-size: 16px;
      color: #666;
      max-width: 500px;
    }

    .btn-group {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        width: 160px;
        height: 44px;
      }
    }
  }
}
</style>
